import { useSnackbar, SnackbarContent, CustomContentProps } from 'notistack';
import { forwardRef, useCallback, useState } from 'react';
import { ITaskResponse, ITaskSearchParam } from 'wisestep-api';
import { WsDialog } from 'wisestep-base';

import { WsTaskCreationCard } from '../../../components/WsTaskCreationCard';
import { closeTask } from '../../../features/tasks/utils/TaskHelper';
import { useNotificationStore } from '../../../utils/NotificationStore';
import NotificationDTO from '../types/NotificationDTO';

import NotificationLayout from './NotificationLayout';
interface CustomNotificationProps extends CustomContentProps {
  notificationTitle?: string;
  notificationSubtext?: string;
  notificationType?: string;
  onClickLink?: string;
  taskDetails?: NotificationDTO;
  customQuery?: ITaskSearchParam;
}
const CustomNotification = forwardRef<HTMLDivElement, CustomNotificationProps>((props, ref) => {
  console.log('properties', props);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const setNotification = useNotificationStore((state) => state.setNotification);

  const generateTaskQuery = (status: string, customQuery?: ITaskSearchParam) => {
    return {
      searchType: 'team',
      status: status,
      dueFromDateTime: null,
      dueTillDateTime: null,
      createdFromDateTime: null,
      createdTillDateTime: null,
      updatedFromDateTime: null,
      updatedTillDateTime: null,
      createdBy: [],
      team: [],
      sort: 'due_date',
      sortDirection: 'DESC',
      size: 50,
      page: 0,
      keywords: '',
      ...(customQuery &&
        customQuery.taskAttributes?.jobCode && {
          taskAttributes: { jobCode: customQuery.taskAttributes.jobCode },
        }),
    };
  };
  const [query, setQuery] = useState<ITaskSearchParam>(generateTaskQuery('ALL', props.customQuery));

  const { notificationTitle, notificationSubtext, notificationType, onClickLink, taskDetails } =
    props;
  const { closeSnackbar } = useSnackbar();
  const handleDismiss = useCallback(() => {
    closeSnackbar();
  }, [closeSnackbar]);
  const timestamp = Number(taskDetails?.data.find((item) => item.key === 'dueDate')?.value);
  const date = new Date(timestamp * 1000);
  const taskMapper: ITaskResponse = {
    id: taskDetails?.data.find((item) => item.key === 'id')?.value ?? '',
    title: taskDetails?.data.find((item) => item.key === 'title')?.value ?? '',
    description: '',
    assignedTo: [taskDetails?.userid ?? ''],
    dueDate: date,
    remindBefore: 0,
    sendEmail: true,
    status: 'OPEN',
    recruiterName: '',
    createdOn: new Date(taskDetails?.createdOn ?? ''),
    createdBy: '',
    modifiedOn: new Date(),
    modifiedBy: '',
    workspaceId: taskDetails?.workspaceId ?? '',
    workspaceName: taskDetails?.workspaceName ?? '',
    teamId: '',
    edits: 1,
    entityId: '',
    entityType: '',
    history: [],
  };
  const onCompleteTask = async (taskId: string) => {
    setNotification(await closeTask(taskId));
    setQuery({ ...query });
  };

  return (
    <SnackbarContent ref={ref}>
      <NotificationLayout
        notificationTitle={notificationTitle}
        notificationSubtext={notificationSubtext}
        notificationType={notificationType}
        onClickLink={onClickLink}
        onCloseHandler={handleDismiss}
        onCompleteTask={() =>
          onCompleteTask(
            taskDetails != undefined
              ? taskDetails?.data.find((item) => item.key === 'id')?.value ?? ''
              : ''
          )
        }
        onSnoozeClick={() => {
          setOpenDialog(!openDialog);
        }}
        taskDetails={taskDetails}
      />
      <WsDialog size="large" openDialog={openDialog}>
        <WsTaskCreationCard
          updateTaskProp={true}
          taskDetails={taskMapper}
          closeDialog={() => setOpenDialog(!openDialog)}
        />
      </WsDialog>
    </SnackbarContent>
  );
});

CustomNotification.displayName = 'CustomNotification';

export default CustomNotification;
